// extracted by mini-css-extract-plugin
export default {"root":"Login_root__KEAHs","widget":"Login_widget__prrPq"};